export const homeKeys = {
  all: ["home"] as const,
  data: (lang?: string) => [...homeKeys.all, "data", lang ?? "en"] as const,
};
